import { Box, Typography } from "@mui/material";
import { StyledCardCurrentPortfolio } from "../../style/styleComponents/StyledCurrentPoerfolio";
import { getColor } from "../../style/color/color";

const LeftSideContent = ({
  ownerClientName,
  premiumReceivedTillDate,
  modelPremium,
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
    }}
  >
    <Typography
      sx={{
        color: getColor.PrimaryWoodSmoke,
        fontSize: "15px",
        fontWeight: "700",
      }}
    >
      {"Axis Max Life Term Plan"}
    </Typography>
    <Box
      sx={{
        pt: 1,
        pb: 1,
      }}
    >
      <Typography
        sx={{
          color: getColor.NeutralDark700,
          fontSize: "13px",
          fontWeight: "700",
        }}
      >
        {ownerClientName}
      </Typography>
      <Typography sx={{ fontSize: "12px", color: getColor.mediumgrey }}>
        Insured Name
      </Typography>
    </Box>
    <Box
      sx={{
        pt: 1,
        pb: 1,
      }}
    >
      <Typography
        sx={{
          color: getColor.NeutralDark700,
          fontSize: "13px",
          fontWeight: "700",
        }}
      >
        {premiumReceivedTillDate}
      </Typography>
      <Typography sx={{ fontSize: "12px", color: getColor.mediumgrey }}>
        Premium
      </Typography>
    </Box>
    <Box
      sx={{
        pt: 1,
        pb: 1,
      }}
    >
      <Typography
        sx={{
          color: getColor.NeutralDark700,
          fontSize: "13px",
          fontWeight: "700",
        }}
      >
        {modelPremium}
      </Typography>
      <Typography sx={{ fontSize: "12px", color: getColor.mediumgrey }}>
        Total Premium Paid
      </Typography>
    </Box>
  </Box>
);

const RightSideContent = ({ policyTerm, sumAssured, issueDate }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
    }}
  >
    <Box
      sx={{
        pt: 1,
        pb: 1,
      }}
    >
      <Typography
        sx={{
          color: getColor.NeutralDark700,
          fontSize: "13px",
          fontWeight: "700",
          textAlign: "right",
        }}
      >
        {policyTerm}
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          textAlign: "right",
          color: getColor.mediumgrey,
        }}
      >
        Policy Term
      </Typography>
    </Box>

    <Box
      sx={{
        pt: 1,
        pb: 1,
      }}
    >
      <Typography
        sx={{
          color: getColor.NeutralDark700,
          fontSize: "13px",
          fontWeight: "700",
          textAlign: "right",
        }}
      >
        {sumAssured}
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          textAlign: "right",
          color: getColor.mediumgrey,
        }}
      >
        Sum Assured
      </Typography>
    </Box>
    <Box
      sx={{
        pt: 1,
        pb: 1,
      }}
    >
      <Typography
        sx={{
          color: getColor.NeutralDark700,
          fontSize: "13px",
          fontWeight: "700",
          textAlign: "right",
        }}
      >
        {issueDate}
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          textAlign: "right",
          color: getColor.mediumgrey,
        }}
      >
        Policy Inception Date
      </Typography>
    </Box>
  </Box>
);

export const CurrentPortfolioCard = ({
  ownerClientName,
  issueDate,
  sumAssured,
  policyTerm,
  premiumReceivedTillDate,
  modelPremium,
}) => (
  <StyledCardCurrentPortfolio>
    <LeftSideContent
      modelPremium={modelPremium}
      ownerClientName={ownerClientName}
      premiumReceivedTillDate={premiumReceivedTillDate}
    ></LeftSideContent>
    <RightSideContent
      issueDate={issueDate}
      policyTerm={policyTerm}
      sumAssured={sumAssured}
    ></RightSideContent>
  </StyledCardCurrentPortfolio>
);
